import Icon from "@ant-design/icons";


const Svg = () => (
    <svg width="99" height="24" viewBox="0 0 99 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4252_13252)">
            </g>
            <defs>
                    <clipPath id="clip0_4252_13252">
                            <rect width="99" height="24" fill="white"/>
                    </clipPath>
            </defs>
    </svg>

)

export const MyIcon = (props) => <Icon component={Svg} {...props}/>